import { Viewer } from './../../analytics/realtime-audience/models/viewer.model';
import { RealtimeService } from './../../../services/realtime.service';
import { Component, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs';

@Component({
	selector: 'bb-realtime-viewers',
	templateUrl: './bb-realtime-viewers.component.html',
	styleUrls: ['./bb-realtime-viewers.component.scss']
})

export class BbRealtimeViewersComponent implements OnDestroy {

	socketViewers = 0;
	viewers = 0;
	mobileViewers = 0;
	realtimeAddSub: Subscription;
	realtimeRemoveSub: Subscription;
	initialCallFinishedSubscription: Subscription;
	viewerCountsSubscription: Subscription;
	usePolling: boolean;

	constructor(private realtimeService: RealtimeService) {
		// usePolling will poll the backend instead of depending on frontend viewerSessions
		this.usePolling = true;

		this.subscribeViewers();

		if (!this.usePolling) {
			this.realtimeService.lostFocus.subscribe((lostFocus: boolean) => {
				if (lostFocus) {
					this.viewers = 0;
					this.mobileViewers = 0;
					if (this.realtimeAddSub) {
						this.realtimeAddSub.unsubscribe();
						this.realtimeAddSub = null;
					}
					if (this.realtimeRemoveSub) {
						this.realtimeRemoveSub.unsubscribe();
						this.realtimeRemoveSub = null;
					}
				} else {
					this.subscribeViewers();
				}
			});
		}
	}

	subscribeViewers() {

		if (this.usePolling) {
			if (!this.viewerCountsSubscription) {
				this.viewerCountsSubscription = this.realtimeService.viewerCountsObs.subscribe((viewerCounts: any) => {
					if (viewerCounts) {
						this.viewers = viewerCounts.viewers || 0;
						this.mobileViewers = viewerCounts.mobileViewers || 0;
					}
				});
			}
		} else {
			if (!this.realtimeAddSub) {
				this.realtimeAddSub = this.realtimeService.viewerAdded.subscribe((viewer: Viewer) => {
					this.viewers++;
					if (viewer.isMobile) {
						this.mobileViewers++;
					}
				});
			}

			if (!this.realtimeRemoveSub) {
				this.realtimeRemoveSub = this.realtimeService.viewerRemoved.subscribe((viewer: Viewer) => {
					this.viewers--;
					if (this.viewers < 0) {
						this.viewers = 0;
					}
					if (viewer.isMobile) {
						this.mobileViewers--;
						if (this.mobileViewers < 0) {
							this.mobileViewers = 0;
						}
					}
				});
			}
		}
	}

	ngOnDestroy() {
		if (this.viewerCountsSubscription) {
			this.viewerCountsSubscription.unsubscribe();
		}
		if (this.realtimeAddSub) {
			this.realtimeAddSub.unsubscribe();
		}
		if (this.realtimeRemoveSub) {
			this.realtimeRemoveSub.unsubscribe();
		}
	}
}
